import styled from 'styled-components'

export const Line = styled.span`
	display: block;
`
